module.exports = __webpack_public_path__ + "img/info-red.ee1d18fe.svg";